export class ParametroPagametoPonto {
  ate: number;
  de: number;
  valor: number;
  id_parametro_pagamento_ponto: number;
}
